import React, { useState, useEffect } from 'react';

import { LoginDropdown } from "./user-login-dropdown.jsx";
import { UserMenu } from "./user-menu.jsx";

import { Info } from "./info.js";
import { Localize } from "./localize.js";
import { RenderTemplate } from "../shared/render-template.js";

import { Optimize } from "../shared/google-optimize.js";

//import { fail } from 'assert';

function NavPhone() {
  const [variant, setVariant] = useState(0); //test test test

  useEffect(() => {
  //  Optimize("Q_hXXO97TG28ifTcK_RrGw")
  //    .then(
  //      d => setVariant(d.variant)/*,
  //      e => console.log(e)*/
  //    )
  },[]);

  var ret = null;

  var style = {};

  //console.log("NavPhone", variant);

  var staff = []
  try {
    staff = window.site_state.pusher.onlinestaff;
  } catch (error) {
    staff = [];
  }
  const hm_online = staff.filter(s => s.isonline).length

  console.log("NavPhone", "staff", staff);

  var phone_number_display = Info.I("phones.dialingcode") + " " + Info.I("phones.number");
  var phone_number = Info.I("phones.countrycode") + Info.I("phones.dialingcode") + Info.I("phones.number");

  // parent node <li className="nav-item d-none d-md-block">

  if (RenderTemplate.RT("render_template.phone_template") == "gomme-auto") {
    ret = (
      <a className="nav-link" href={"tel:" + phone_number} name={Localize.L('telefonaci')}>
        <div style={style}>
          <div style={{ fontFamily: "'PT Sans Narrow',sans-serif", fontWeight: 700, fontSize: "18px", lineHeight: "18px" }}>{Localize.L("Telefono")}</div>
          <div style={{ fontFamily: "'PT Sans Narrow',sans-serif", fontWeight: 400, fontSize: "14px", letterSpacing: "-0.04em" }}>{phone_number_display}</div>
        </div>
      </a>
    );
  }
  else {
    var bgColor = "rgba(255, 133, 27, .8)";

    if (window.location.pathname.includes("cart") || window.location.pathname.includes("contact-us")) {
      bgColor = "#AAAAAA";
    }

    style = { backgroundColor: bgColor };

    ret = (
      <a className="nav-link phone" href={"/contact-us"} name={Localize.L('contattaci')}>
        <div style={style}>
          <div style={{ fontFamily: "Roboto Condensed", fontSize: "16px" }}>{Localize.L("Per parlare con noi")}</div>
          <div style={{ fontFamily: "Roboto Condensed", fontWeight: 400, fontSize: "16px" }}>({Localize.L("siamo")} <span className="badge badge-success">{hm_online}</span> {Localize.L("online")})</div>
        </div>
      </a>
    );

    //switch (variant) {
    //  case 1:
    //    ret = (
    //      <a className="nav-link phone" href={"/contact-us"} name={Localize.L('contattaci')}>
    //        <div style={style}>
    //          <div style={{ fontFamily: "Roboto Condensed", fontSize: "14px" }}>{Localize.L("Per parlare con noi")}</div>
    //          <div style={{ fontFamily: "Roboto Condensed", fontWeight: 700, fontSize: "20px" }}><i className="fas fa-phone" data-fa-transform="flip-h rotate--20"></i> clicca qui</div>
    //        </div>
    //      </a>
    //    );
    //    break;
    //  default:
    //    ret = (
    //      <a className="nav-link phone" href={"tel:" + phone_number} name={Localize.L('telefonaci')}>
    //        <div style={style}>
    //          <div style={{ fontFamily: "Roboto Condensed", fontSize: "14px" }}>{Localize.L("Per ordini ed assistenza")}</div>
    //          <div style={{ fontFamily: "Roboto Condensed", fontWeight: 700, fontSize: "20px" }}><i className="fas fa-phone" data-fa-transform="flip-h rotate--20"></i> {phone_number_display}</div>
    //        </div>
    //      </a>
    //    );
    //    break;
    //}
  }

  return ret;
}

class NavLogin extends React.Component {
  state = {
    ui: {
      UserMenu: false,
      LoginDropdown: false
    }
  };

  toggle = (e, n) => {
    const name = e.target.name || n;
    this.setState(Object.assign({}, this.state, { ui: { [name]: !this.state.ui[name] } }));
  }

  render() {
    //console.log("navbar", "render", this.props.user);

    var bgColor = "rgba(255, 133, 27, .8)";
    if (window.location.pathname.includes("cart")) {
      bgColor = "#AAAAAA";
    }
    var style = { backgroundColor: bgColor };

    var loginOrMenu = null;
    if (this.props.user && this.props.user.isauthenticated) {
      loginOrMenu = <UserMenu toggle={this.toggle} show={this.state.ui.UserMenu} user={this.props.user} />;
    } else {
      loginOrMenu = <LoginDropdown toggle={this.toggle} show={this.state.ui.LoginDropdown} />;
    }

    return loginOrMenu;

    //    <NavMiniCart toggle={this.toggle} show={this.state.ui.NavMiniCart} />
  }
}

function ContactCenterLinkTo() {
  const [variant, setVariant] = useState(0); //test test test

  //useEffect(() => {
  //  Optimize("Q_hXXO97TG28ifTcK_RrGw")
  //    .then(
  //      d => setVariant(d.variant)/*,
  //      e => console.log(e)*/
  //    )
  //}, []);

  var ret = null;

  var style = {};

  var bgColor = "rgba(255, 133, 27, .8)";

  if (window.location.pathname.includes("cart") || window.location.pathname.includes("contact-us")) {
    bgColor = "#AAAAAA";
  }

  style = { backgroundColor: bgColor };

  switch (variant) {
    case 1:
      ret = (
        <a className="phone" href={"/contact-us"} name={Localize.L('contattaci')}>
          <div style={style} className="footer-phone">
            <div style={{ fontFamily: "Roboto Condensed", fontSize: "14px" }}>{Localize.L("Per parlare con noi")}</div>
            <div style={{ fontFamily: "Roboto Condensed", fontWeight: 700, fontSize: "20px" }}><i className="fas fa-phone" data-fa-transform="flip-h rotate--20"></i> {Localize.L("clicca qui")}</div>
          </div>
        </a>
      )
      break
    default:
      ret = (
        <a href="/contact-us">{Localize.L("Servizio Clienti")}</a>
      )
      break
  }

  return ret;
}

export { ContactCenterLinkTo }
export { NavPhone }
export { NavLogin } 